var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","small":""},on:{"click":_vm.newWord}},on),[_c('v-icon',{staticClass:"mr-2"},[_vm._v("mdi-refresh")])],1)]}}])},[_vm._v(" New word ")])}
var staticRenderFns = []

export { render, staticRenderFns }